import axios from "@/axios";
import { seemsAuthenticated } from "@/axios";
import { AuthResponse } from "@/types/resellersNUsers";
import { captureException } from "@sentry/react";
import { useQuery } from "@tanstack/react-query";

export default function useMe() {
  const { data: meData, ...useQueryResult } = useQuery({
    queryKey: ["auth"],
    queryFn: async () => {
      try {
        const response = await axios.get<AuthResponse>("/bff/api/auth/me/");
        return response.data;
      } catch (e) {
        console.error(e);
        captureException(e);
        throw e;
      }
    },
    enabled: seemsAuthenticated(),
  });

  return { meData, ...useQueryResult };
}
